<template>
    <div>
        <div class="toolbar-compensation"></div>
        <v-toolbar class="content-toolbar">
            <v-btn flat class="back-button" v-on:click="$router.go(-1)">
                <font-awesome-icon :icon="['far', 'chevron-left']" size="2x"/>
            </v-btn>
            <v-toolbar-title>API Keys</v-toolbar-title>

        </v-toolbar>
        <div class="container">
            <v-data-table
                    :headers="headers"
                    :items="ApiKeys.data"
                    :loading="ApiKeys.state === LOADING_STARTED"
                    hide-actions
                    class="elevation-1">
                <v-progress-linear slot="progress" :indeterminate="true" color="accent"></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td>
                        <div class="key-column-container">
                            <span v-if="props.item.showState">
                                <span class="body-2">{{props.item.key}}</span>
                                <span class="hide-button">
                                    <v-btn small flat class="mx-0" @click="toggleKeyShowState(props.item)">
                                        <span>Hide</span>
                                    </v-btn>
                                </span>
                            </span>
                            <span v-else>
                            <v-btn small flat class="mx-0" @click="toggleKeyShowState(props.item)">
                                <span>Show</span>
                            </v-btn>
                        </span>
                        </div>
                    </td>
                    <td>
                        <v-btn icon class="mx-0" @click="confirmDelete(props.item)">
                            <span><font-awesome-icon :icon="['fal', 'minus-circle']" size="2x" color="red"/></span>
                        </v-btn>
                    </td>
                </template>
            </v-data-table>
            <div class="new-key-dialog-container">
                <v-dialog v-model="newKeydialog" max-width="500px">
                    <v-btn slot="activator" class="add-key-button" color="green" dark fab>
                        <span><font-awesome-icon :icon="['fal', 'plus']"/></span>
                    </v-btn>
                    <v-card>
                        <v-card-title>
                            <span class="headline">New Key</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex>
                                        <v-text-field v-model="newKey.data.name" label="Key name"
                                                      color="accent"></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
                            <v-btn color="blue darken-1" flat @click.native="save">Add</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </div>
        <v-dialog v-model="confirmDeleteDialogState" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Warning! Key deletion</v-card-title>
                <v-card-text>Continuing will permanently delete the selected key. If you would like to abort, click
                    cancel. Otherwise, click continue.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="handleConfirmDeleteDialogResponse(false)">Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" flat @click.native="handleConfirmDeleteDialogResponse(true)">Continue
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {
        LOADING_PRISTINE,
        LOADING_STARTED,
        LOADING_COMPLETED_SUCCESS,
        LOADING_COMPLETED_FAILURE,
    } from "../services/constants"
    import BaseLoadingComponent from './BaseLoading'
    import http from '../services/axios'
    import lodash from '../services/lodash'

    export default {
        name: 'settings-delivery-key',
        extends: BaseLoadingComponent,
        data: function () {
            return {
                newKeydialog: false,
                confirmDeleteDialogState: false,
                headers: [
                    {text: 'Name', value: 'name'},
                    {text: 'Key', value: 'key'},
                    {text: 'Actions', value: 'name', sortable: false}
                ],
                ApiKeys: {
                    state: LOADING_PRISTINE,
                    data: [],
                    err: null,
                },
                newKey: {
                    state: LOADING_PRISTINE,
                    data: null,
                    err: null,
                },
                deleteKey: {
                    state: LOADING_PRISTINE,
                    data: null,
                    err: null,
                },
                keyTemplate: {
                    name: '',
                },
            }
        },
        computed: {
            spaceMetaData: function () {
                return this.$store.state.spaceMetadata
            },
        },
        watch: {
            spaceMetaData: function () {
                this.init()
            },
        },
        methods: {
            getDeliveryKeys: function () {
                this.ApiKeys = {
                    state: LOADING_STARTED,
                    data: [],
                    err: null,
                }

                http.get(`api/management/spaces/${this.$store.state.spaceMetadata.id}/keys`)
                    .then(response => {
                        const mappedResults = response.data.map(key => {
                            key['showState'] = false
                            return key

                        })
                        this.ApiKeys = {
                            state: LOADING_COMPLETED_SUCCESS,
                            data: mappedResults,
                            err: null,
                        }
                    })
                    .catch(err => {
                        this.ApiKeys = {
                            state: LOADING_COMPLETED_FAILURE,
                            data: [],
                            err: err,
                        }
                    })
            },
            addNewDeliveryKey: function () {
                this.newKey.state = LOADING_STARTED
                http.post(`api/management/spaces/${this.$store.state.spaceMetadata.id}/keys`, this.newKey.data)
                    .then(response => {
                        this.newKey = {
                            state: LOADING_COMPLETED_SUCCESS,
                            data: lodash.cloneDeep(this.keyTemplate),
                            err: null,
                        }
                        this.getDeliveryKeys()
                    })
                    .catch(err => {
                        this.newKey = {
                            state: LOADING_COMPLETED_FAILURE,
                            data: lodash.cloneDeep(this.keyTemplate),
                            err: err,
                        }
                        this.newKey.state = LOADING_COMPLETED_FAILURE
                        this.newKey.err = err
                    })
            },
            init: function () {
                this.newKey = {
                    state: LOADING_PRISTINE,
                    data: lodash.cloneDeep(this.keyTemplate),
                    err: null,
                }
                if (this.spaceMetaData) {
                    this.getDeliveryKeys()
                }
            },

            toggleKeyShowState(key) {
                key.showState = !key.showState
            },

            deleteDeliveryKey() {
                this.deleteKey.state = LOADING_PRISTINE

                http.delete(`api/management/spaces/${this.$store.state.spaceMetadata.id}/keys/${this.deleteKey.data.key}`)
                    .then(response => {
                        this.deleteKey = {
                            state: LOADING_COMPLETED_SUCCESS,
                            data: null,
                            err: null,
                        }
                        this.getDeliveryKeys()
                    })
                    .catch(err => {
                        this.deleteKey = {
                            state: LOADING_COMPLETED_FAILURE,
                            data: null,
                            err: err,
                        }
                    })
            },
            confirmDelete(key) {
                this.deleteKey.data = lodash.cloneDeep(key)
                this.confirmDeleteDialogState = true
            },
            handleConfirmDeleteDialogResponse(response) {
                this.confirmDeleteDialogState = false
                if (response) {
                    this.deleteDeliveryKey()
                }
            },

            close() {
                this.newKeydialog = false
                this.newKey = {
                    state: LOADING_PRISTINE,
                    data: lodash.cloneDeep(this.keyTemplate),
                    err: null,
                }
            },

            save() {
                this.addNewDeliveryKey()
                this.close()
            }
        },
        created: function () {
            this.init()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .toolbar-compensation {
        height: 64px;
    }

    .back-button {
        height: 100%;
        margin: 0 1em 0 0;
    }

    .key-column-container {
        width: 25em;
    }

    .hide-button {
        margin: 0 0 0 1em;
    }

    .new-key-dialog-container {
        display: flex;
        justify-content: flex-end;
    }

    .add-key-button {
        margin: 1em 0 0 0;
    }

    .body-2 {
        color: #616161;
    }
</style>